export const FACEBOOK_BIG_TEXT_LENGTH_THRESHOLD = 85;
